// import PeMoreInfo from "../../components/PeMoreInfo";
import PeSingleChoice from "../../components/PeSingleChoice";
import AddressAutoComplete from '../../components/PeAddressFields';
import PeSubsidy from "../../components/PeSubsidy";

const installOpt = {
    type_phase: [
        { label: "Single Phase", value: "single_phase" },
        { label: "Three Phase", value: "three_phase" },
    ],
};

export const installationStepField = [
    {
        name: "full_address",
        component: AddressAutoComplete,
        siblingField: ["zip", "locality", "state", "country_iso2", "lat", "lon"],
        props: {
          label: "Your Install Address",
          toolTip: "Enter your install address so we can determine any applicable Federal Government and State Government upfront discounts as well as confirm your water quality",
          required: true,
        },
    }, 
    {
        name: "choice_type_install",
        dependOn: "full_address",
        component: PeSingleChoice,
        props: {
            label: "Single Phase or Three Phase?",
            toolTip: "Do you have an existing HWS that needs replacing with a Sanden or is it a New Build/Renovation where there is no hot water system present?",
            required: true,
            options: installOpt.type_phase,
        },
        condition: [{
            value: "single_phase",
            fieldChild: [{
                name: "subsidies",
                dependOn: "exist_hws_gt_3yr",
                component: PeSubsidy,
                props: {
                    label: "Applicable Subsidies",
                    toolTip: "",
                },
            }]
        }, 
        {
            value: "three_phase",
            fieldChild: [{
                name: "subsidies",
                dependOn: "exist_hws_gt_3yr",
                component: PeSubsidy,
                props: {
                    label: "Applicable Subsidies",
                    toolTip: "",
                },
            }]
        }
        ]
    },
]